import React from "react";
import {logout} from "@/util/authentication";
import {useHistory} from "react-router";
import style from "./menu.scss";
import Layout from "@/layout/Layout";
import {Logo} from "@/components/atom/Logo";

const Menu = () => {
  const history = useHistory()

  const doLogout = (e) => {
    logout()
    document.location.href = '/'
  }

  const toCard = () => {
    history.push('/card')
  }

  const toUpload = () => {
    history.push('/card/upload')
  }

  const toSchedule = () => {
    history.push('/schedule/edit')
  }

  const toSetting = () => {
    history.push('/setting')
  }

  const toUketori = () => {
    history.push('/uketori')
  }

  const toTermInfo = () => {
    history.push('/termInfo')
  }

  return (
    <div className="App">
      <Layout needTopBar={false}>
        <div className={style.buttons}>
          <div>
            <Logo/>
          </div>
          <button className={style.menuButton} type="button" onClick={toCard}>名刺の一覧</button>
          <button className={style.menuButton} type="button" onClick={toUpload}>名刺の登録</button>
          <button className={style.menuButton} type="button" onClick={toSchedule}>年間スケジュール作成</button>
          <button className={style.menuButton} type="button" onClick={toUketori}>受取名刺</button>
          <button className={style.menuButton} type="button" onClick={toSetting}>設定</button>
          <button className={style.menuButton} type="button" onClick={toTermInfo}>規約等</button>
          <button className={style.menuButton} type="button" onClick={doLogout}>ログアウト</button>
        </div>
      </Layout>
    </div>
  )
}

export default Menu;
